import { subscriptionService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";

export const useMarkInactiveViewModel = ({ user, onClose, onRefresh }) => {
  const stateManager = useComponentState();
  const isLoading = stateManager.isBusy();

  const createUserLog = async (data) => {
    stateManager.run(async () => {
      const response =
        await subscriptionService.users.createUserAvailabilityLog({
          data,
          toastMessageConfig: {
            success: {
              text: `${user?.name} was successfully marked inactive.`,
            },
          },
        });

      if (response.status === HTTP_STATUSES.CREATED) {
        onClose();
        onRefresh();
      }
    });
  };

  return { isLoading, createUserLog };
};
